<div ngbDropdown [container]="container">
  <button
    type="button"
    class="btn more-actions-button"
    (click)="$event.stopPropagation()"
    [ngbTooltip]="tooltipText"
    container="body"
    placement="top"
    ngbDropdownToggle
    aria-label="Mais ações">
    <i class="fas fa-ellipsis-v"></i>
  </button>
  <div ngbDropdownMenu class="dropdown-menu-right">
    <ng-content></ng-content>
  </div>
</div>
